import React, { useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { ManageAccount12MonthsContext } from './dash_12MServiceProvider';
import formatters from '../../../../Core/Grid/inputFormatter';
import AppContext from '../../../../App/AppContext';
import { CircularProgress, Grid } from '@material-ui/core';

const StyledTableCell = withStyles((theme) => ({
    head: {
        padding: '5px 10px',
        fontSize: 12,
        border: '1px solid rgba(0,0,0,0.03)'
    },
    body: {
        fontSize: 12,
        padding: '6px 10px',
        border: '1px solid rgba(0,0,0,0.03)'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: 1280
    }
});

export default function Dashboard12MTable() {
    const classes = useStyles();
    const { showToast } = useContext(AppContext);
    const { months, state, getOverallAccountCodeData, getCalculateData } = useContext(ManageAccount12MonthsContext);

    return state.showLoader ? (
        <Grid container alignItems="center" justifyContent="center" style={{ height: '400px' }}>
            <Grid item>
                <CircularProgress />
            </Grid>
        </Grid>
    ) : state.getNameList.length == 0 ? (
        <Grid container alignItems="center" justifyContent="center" style={{ height: '400px' }}>
            <Grid item>No Record Found </Grid>
        </Grid>
    ) : (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
                {state.Category.map((cat, index) => {
                    let count = 0;
                    const isCalculated = cat.calculated == 1;
                    const isTotalCalculated = cat.calculated == 2;
                    const calculationList = getCalculateData(isCalculated || isTotalCalculated, cat.calculation, cat.categoryId);

                    return (
                        <>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell
                                        style={{
                                            backgroundColor: state.bgColor,
                                            color: state.txtColor
                                        }}
                                    >
                                        {cat.categoryName}
                                    </StyledTableCell>
                                    {months.map((k) => (
                                        <StyledTableCell
                                            align="right"
                                            key={`${cat.categoryName}-month${k.id}`}
                                            style={{
                                                backgroundColor: state.bgColor,
                                                color: state.txtColor
                                            }}
                                        >
                                            {k.name}
                                        </StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isCalculated
                                    ? calculationList
                                          .filter((k) => k.mappingCategoryID === cat.categoryId)
                                          .filter(
                                              (item, index, self) => index === self.findIndex((t) => t.maMappingCategoryName === item.maMappingCategoryName)
                                          )
                                          .map((row, index) => {
                                              count++;
                                              return (
                                                  <StyledTableRow key={`row-${index}`}>
                                                      {
                                                          <StyledTableCell component="th" scope="row" width={'200px'}>
                                                              {row.maMappingCategoryName}
                                                          </StyledTableCell>
                                                      }
                                                      {months.map((k) => {
                                                          let getActualValue = () => {
                                                              let getValue = calculationList.find(
                                                                  (item) =>
                                                                      row.maMappingCategoryName === item.maMappingCategoryName &&
                                                                      item.period === k.id &&
                                                                      item.mappingCategoryID === cat.categoryId
                                                              );
                                                              return getValue ? getValue.actual : 0;
                                                          };

                                                          return (
                                                              <StyledTableCell align="right" key={`k.id+${k.name}`} width={'100px'}>
                                                                  {formatters.ThousandSeparatorWithoutZero(getActualValue())}
                                                              </StyledTableCell>
                                                          );
                                                      })}
                                                  </StyledTableRow>
                                              );
                                          })
                                    : !isTotalCalculated &&
                                      state.getNameList
                                          .filter((k) => k.maDashboardCategoryId === cat.categoryId)
                                          .filter(
                                              (item, index, self) => index === self.findIndex((t) => t.maMappingCategoryName === item.maMappingCategoryName)
                                          )
                                          .map((row, index) => {
                                              count++;
                                              return (
                                                  <StyledTableRow key={`row-${index}`}>
                                                      {
                                                          <StyledTableCell component="th" scope="row" width={'200px'}>
                                                              {row.maMappingCategoryName}
                                                          </StyledTableCell>
                                                      }
                                                      {months.map((k) => {
                                                          let getActualValue = () => {
                                                              let getValue = state.getNameList.find(
                                                                  (item) =>
                                                                      row.maMappingCategoryName === item.maMappingCategoryName &&
                                                                      item.period === k.id &&
                                                                      item.maDashboardCategoryId === cat.categoryId
                                                              );
                                                              return getValue ? getValue.actual : 0;
                                                          };

                                                          return (
                                                              <StyledTableCell align="right" key={`k.id+${k.name}`} width={'100px'}>
                                                                  {formatters.ThousandSeparatorWithoutZero(getActualValue())}
                                                              </StyledTableCell>
                                                          );
                                                      })}
                                                  </StyledTableRow>
                                              );
                                          })}
                                {cat.showTotalFooter && (
                                    <StyledTableRow>
                                        <StyledTableCell component="th" scope="row" style={{ backgroundColor: cat.footerBgColor, color: cat.footerTextColor }}>
                                            <strong>{cat.footerTitle}</strong>
                                        </StyledTableCell>
                                        {!cat.calculated
                                            ? months.map((k) => {
                                                  const total = state.getNameList.reduce((acc, item) => {
                                                      if (item.maDashboardCategoryId === cat.categoryId && item.period === k.id) {
                                                          return acc + (item.actual || 0);
                                                      }
                                                      return acc;
                                                  }, 0);

                                                  return (
                                                      <StyledTableCell
                                                          align="right"
                                                          key={`total-${cat.categoryId}-${k.id}`}
                                                          style={{ backgroundColor: cat.footerBgColor, color: cat.footerTextColor }}
                                                      >
                                                          {cat.budgetHasTotal ? (
                                                              <strong>{formatters.ThousandSeparatorWithoutZero(total)}</strong>
                                                          ) : (
                                                              <strong>{formatters.ThousandSeparatorWithoutZero(total / count)}</strong>
                                                          )}
                                                      </StyledTableCell>
                                                  );
                                              })
                                            : months.map((k) => {
                                                  const total = calculationList.reduce((acc, item) => {
                                                      if (item.period === k.id && item.mappingCategoryID === cat.categoryId) {
                                                          return acc + (item.actual || 0);
                                                      }
                                                      return acc;
                                                  }, 0);

                                                  return (
                                                      <StyledTableCell
                                                          align="right"
                                                          key={`total-${cat.categoryId}-${k.id}`}
                                                          style={{ backgroundColor: cat.footerBgColor, color: cat.footerTextColor }}
                                                      >
                                                          {cat.budgetHasTotal ? (
                                                              <strong>{formatters.ThousandSeparatorWithoutZero(total)}</strong>
                                                          ) : (
                                                              <strong>{formatters.ThousandSeparatorWithoutZero(total / count)}</strong>
                                                          )}
                                                      </StyledTableCell>
                                                  );
                                              })}
                                    </StyledTableRow>
                                )}
                                <StyledTableRow>
                                    <StyledTableCell style={{ padding: '0px 40px', background: 'white', border: 'none' }} align="center" colSpan={13}>
                                        {/* <hr className="sep-2" /> */}
                                        &nbsp;
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </>
                    );
                })}
            </Table>
        </TableContainer>
    );
}
